<template>
	<div class="form-container">
		<h3 class="vrnu-headline">{{ formData }}</h3>
		<b-form v-on:submit.prevent="save">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<b-form-group
							label="Name"
							label-for="name">
							<b-form-input id="name"
								type="text"
								placeholder="Name"
								v-model.trim="provider.name"
								v-validate="'required'"
								data-vv-name="Name"
								:class="{'has-error': errors.has('Name')}">
							</b-form-input>
							<p v-if="errors.has('Name')" class="error-message">
								{{ errors.first('Name') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="Kategorie"
							label-for="category">
							<b-form-select 	v-model.trim="provider.category"
											:options="options"
											class="mb-3"
											data-vv-name="Kategorie"
											v-validate="'required'"
											:class="{'has-error': errors.has('Kategorie')}"></b-form-select>
							<p v-if="errors.has('Kategorie')" class="error-message">
								{{ errors.first('Kategorie') }}
						    </p>
						</b-form-group>					
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="Logo"
							label-for="brandImage">
							<vrnu-image-selector 	v-model.trim="provider.brandImage"
													v-validate="'required'"
													data-vv-name="Logo"
													:class="{'has-error': errors.has('Logo')}">
							</vrnu-image-selector>
							<p v-if="errors.has('Logo')" class="error-message">
								{{ errors.first('Logo') }}
						    </p>
						</b-form-group>						
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="Straße"
							label-for="street">
							<b-form-input id="street"
								type="text"
								v-model.trim="provider.street"
								v-validate="'required'"
								data-vv-name="Strasse"
								:class="{'has-error': errors.has('Strasse')}">
							</b-form-input>
							<p v-if="errors.has('Strasse')" class="error-message">
								{{ errors.first('Strasse') }}
						    </p>							
						</b-form-group>						
					</b-col>
					<b-col>
						<b-form-group
							label="Hausnummer"
							label-for="houseNumber">
							<b-form-input id="houseNumber"
								type="text"
								v-model.trim="provider.houseNumber"
								v-validate="'required'"
								data-vv-name="Hausnummer"
								:class="{'has-error': errors.has('Hausnummer')}">
							</b-form-input>
							<p v-if="errors.has('Hausnummer')" class="error-message">
								{{ errors.first('Hausnummer') }}
						    </p>
						</b-form-group>						
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="PLZ"
							label-for="zip">
							<b-form-input id="zip"
								type="text"
								v-model.trim="provider.zip"
								v-validate="'required|digits:5'"
								data-vv-name="PLZ"
								:class="{'has-error': errors.has('PLZ')}">
							</b-form-input>
							<p v-if="errors.has('PLZ')" class="error-message">
								{{ errors.first('PLZ') }}
						    </p>
						</b-form-group>						
					</b-col>
					<b-col>
						<b-form-group
							label="Ort"
							label-for="city">
							<b-form-input id="city"
								type="text"
								v-model.trim="provider.city"
								v-validate="'required'"
								data-vv-name="Ort"
								:class="{'has-error': errors.has('Ort')}">
							</b-form-input>
							<p v-if="errors.has('Ort')" class="error-message">
								{{ errors.first('Ort') }}
						    </p>
						</b-form-group>						
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="Aktiv"
							label-for="active">
							<b-form-checkbox id="active"
						                     v-model.trim="provider.active"
						                     value="true"
						                     unchecked-value="false">
						      Der Anbieter ist aktiv und wird in der App angezeigt
						    </b-form-checkbox>
						</b-form-group>						
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<maps-location-selector v-bind:initialLocation="adress"
												v-model.trim="provider.location"></maps-location-selector>
					</b-col>
				</b-row>
			</b-container>
			<b-button type="submit" class="vrnu-button" variant="primary">Speichern</b-button>
			<b-button type="reset" variant="secondary">Zurücksetzen</b-button>
		</b-form>		
	</div>
</template>

<script>
// Organize imports
import MapsLocationSelector from '@/components/98_ui/MapsLocationSelector';
import ImageSelector from '@/components/98_ui/ImageSelector';

export default {
	data: function() {
		return {
			isUpdate: false,
			provider: {
				name: '',
				category: null,
				street: '',
				houseNumber: '',
				zip: '',
				city: '',
				location: '',
				brandImage: null,
				active: true,
			},
			options: [
				{ value: null, text: 'Bitte wählen Sie eine Kategorie' },
				{ value: 'leisure', text: 'Freizeit' },
				{ value: 'sports', text: 'Sport' },
				{ value: 'shops', text: 'Shopping' },
				{ value: 'season', text: 'Saisonales' },
				{ value: 'food', text: 'Essen & Getränke' }, 	
			],
		};
	},
	computed: {
		adress: function() {
			return {
				street: this.provider.street,
				houseNumber: this.provider.houseNumber,
				city: this.provider.city,
				zip: this.provider.zip,
        // latitude: this.provider.location.lat,
        // longitude: this.provider.location.lon,
			};
		},
	},
	methods: {
		save: function() {
			this.$validator.validate().then(result => {
				if (!result) {
					console.log("errors", this.$validator.errors);					
				} else {
					// Create a new data object
					var data = {							
							name: this.provider.name,
							category: this.provider.category,
							street: this.provider.street,
							houseNumber: this.provider.houseNumber,
							zip: this.provider.zip,
							city: this.provider.city,
							lat: this.provider.location.lat,
							lon: this.provider.location.lon,
							brandImage: this.provider.brandImage,
							active: this.provider.active
					};

					// Send provider to the server
					if(this.isUpdate) {
						// Update the provider
		 				this.$http.put('providers/' + this.updateId, data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});				
					} else {								
						// Save the provider
						this.$http.post('providers', data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});
					}
				}
			});
		},
		loadProviderForUpdate: function() {
			// Get provider from server
			this.$http.get('providers/' + this.updateId).then(provider => {
				this.provider = {
					_id: provider.body._id,
					name: provider.body.name,
					category: provider.body.category,
					street: provider.body.street,
					houseNumber: provider.body.houseNumber,
					zip: provider.body.zip,
					city: provider.body.city,
					location: {
						lat: provider.body.lat,
						lon: provider.body.lon,
					},
					brandImage: provider.body.brandImage._id,
					active: provider.body.active,
				};
			}, response => {
				console.log(response);
				this.providers = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		checkIfModeIsUpdate: function() {
			if(this.updateId !== null) {
				this.isUpdate = true;
				this.loadProviderForUpdate();
			} else {
				this.isUpdate = false;
			}
		},
	},
	watch: {
		updateId: function() {
			this.checkIfModeIsUpdate();
		},
	},
	created: function() {
		this.checkIfModeIsUpdate();
		this.$validator.localize('de');
	},
	mounted: function() {
	},
	props: {
		formData: {
			required: true,
		},
		updateId: {
			default: null,
		}
	},
	components: {
		'maps-location-selector': MapsLocationSelector,
		'vrnu-image-selector': ImageSelector,
	}
}
</script>

<style>
.form-container {
	padding: 5px;
}
.mb-3 {
	margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/03_provider/ProvidersForm.vue